import { GetString } from 'fluent-react';
import React from 'react';
import styled from 'styled-components';
import { PolicyRecommendation } from '../../graphQL/types/shared';
import { policyColors } from '../rockSongChart/Utils';
import SectionLabel from './SectionLabel';

const PolicyText = styled.div`
  font-size: 22px;
  font-weight: 600;
  padding-top: 0.7rem;
  display: inline-block;
  vertical-align: top;
  grid-row: 2;
  grid-column: 2;

  @media screen and (max-width: 1200px), screen and (max-height: 700px) {
    padding-top: 0;
    font-size: 0.9rem;
    grid-column: 1 / 3;
    display: flex;
    align-items: center;
  }

  @media (max-width: 850px) {
    font-size: 0.75rem;
  }
`;

const IconOuterContainer = styled.div`
  width: 22px;
  padding-top: 6px;
  float: left;

  @media screen and (max-width: 1200px), screen and (max-height: 700px) {
    padding-top: 2px;
    padding-bottom: 2rem;
    width: 8px;
  }
`;

const PolicyTextContainer = styled.div`
  margin-left: 35px;

  @media screen and (max-width: 1200px), screen and (max-height: 700px) {
    margin-left: 10px;
    padding-bottom: 2rem;
  }
`;

interface Props {
  policyRecommendation: PolicyRecommendation;
  getFluentString: GetString;
}

const PolicyRecommendationBadge = (props: Props) => {
  const {policyRecommendation, getFluentString} = props;
  const color: string = policyColors[policyRecommendation];
  let policyText: string;
  switch (policyRecommendation) {
    case PolicyRecommendation.ParsimoniousIndustrial:
      policyText = getFluentString('strategic-approach-name-parsimonious-industrial');
      break;
    case PolicyRecommendation.LightTouch:
      policyText = getFluentString('strategic-approach-name-light-touch');
      break;
    case PolicyRecommendation.StrategicBets:
      policyText = getFluentString('strategic-approach-name-strategic-bets');
      break;
    default:
      policyText = getFluentString('strategic-approach-name-parsimonious-industrial');
      break;
  }
  return (
    <>
      <SectionLabel
        num={1}
        title={getFluentString('policy-dimensions-control-title-text-1')}
      />
      <PolicyText style={{color}}>
        <IconOuterContainer
          style={{fill: color}}
          dangerouslySetInnerHTML={{__html: require('../rockSongChart/policy.svg')}}
        />
        <PolicyTextContainer>
          {policyText}
        </PolicyTextContainer>
      </PolicyText>
    </>
  );
};

export default PolicyRecommendationBadge;
